$(document).ready(function () {
    $('.image-text-card-carousel .owl-carousel').owlCarousel({
        loop: true,
        items: 1,
        margin: 10,
        nav: true,
        navText: ["", ""],
        dots: false
    });
    
    $('.regioal-govt-card-carousel .owl-carousel').owlCarousel({
        loop: true,
        items: 1,
        margin: 10,
        nav: true,
        navText: ["", ""],
        dots: true
    });
    
    $('.data-sustainable-carousel .owl-carousel').owlCarousel({
        loop: true,
        items: 1,
        margin: 10,
        nav: false,
        dots: true
    });

    $('.elearning-with-multimedia-carousel .owl-carousel').owlCarousel({
        loop: ( $('.owl-carousel .items').length > 4 ),
        items: 2,
        margin: 20,
        nav: false,
        dots: false,
        responsive: {
            0: { items: 1 },
            768: { items: 1 },
            1000: { items: 3 }
        }
    });
    
    var owl_elearning = $('.elearning-with-multimedia-carousel .owl-carousel');
    owl_elearning.owlCarousel();
    $('.slide-next').click(function () { owl_elearning.trigger('next.owl.carousel'); });
    $('.slide-prev').click(function () { owl_elearning.trigger('prev.owl.carousel'); });

    $('.best-practices-carousel .owl-carousel').owlCarousel({
        loop: ( $('.owl-carousel .items').length > 4 ),
        margin: 15,
        nav: true,
        navText: ["", ""],
        dots: false,
        responsive: {
            0: { items: 1 },
            600: { items: 3 },
            1000: { items: 4 }
        }
    });
    
    $('.feature-report-carousel .owl-carousel').owlCarousel({
        loop: true,
        margin: 30,
        nav: true,
        navText: ["", ""],
        dots: true,
        responsive: {
            0: { items: 1 },
            600: { items: 2 },
            1000: { items: 2 }
        }
    });
    $('.related-carousel .owl-carousel').owlCarousel({
        loop: true,
        margin: 15,
        nav: true,
        navText: ["", ""],
        dots: true,
        responsive: {
            0: { items: 1 },
            600: { items: 2 },
            1000: { items: 2 }
        }
    });
    
    $('.best-practices-knowledge-carousel .owl-carousel').owlCarousel({
        loop: ( $('.owl-carousel .items').length > 3 ),
        margin: 15,
        nav: true,
        navText: ["", ""],
        dots: true,
        responsive: {
            0: { items: 1 },
            600: { items: 2 },
            1000: { items: 3 }
        }
    });
    
    $('.action-carousel .owl-carousel').owlCarousel({
        loop: ( $('.owl-carousel .items').length > 2 ),
        margin: 15,
        nav: true,
        navText: ["", ""],
        dots: true,
        responsive: {
            0: { items: 1 },
            600: { items: 1 },
            1000: { items: 2 }
        }
    });
    $('.partners-carousel .owl-carousel').owlCarousel({
        loop: true,
        margin: 20,
        nav: true,
        autoplay: true,
        autoplayTimeout: 3000,
        dots: false,
        responsive: {
            0: { items: 1 },
            600: { items: 3 },
            960: { items: 5 },
            1200: { items: 6 }
        }
    });
});
